<po-page-default>
  <app-welcome></app-welcome>
  <app-breadcrumb></app-breadcrumb>
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 sales-group">
    <po-widget>
      <div class="po-row">
        <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7">
          <span class="po-font-text-bold ">Venda por grupo</span>
          <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" [p-tooltip]="topTooltipExcel" (click)="downloadExcel()"></span>
        </div>
      </div>
      <div *ngIf="!errorApi">
        <po-table [p-items]="tableRanking" [p-actions]="actions" [p-sort]="true" [p-loading]="loading" [p-striped]="true"></po-table>
      </div>
      <div class="po-text-center po-pt-5" *ngIf="errorApi">
        <app-error [message]="message"></app-error>
      </div>
    </po-widget>
  </div>
</po-page-default>